import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-summary gfu-box gfu-box--flat gfu-box--fill" }
const _hoisted_2 = {
  class: "gfu-project-summary-completed",
  "data-qa": "project-summary-box:Completed"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_summary_completed_stats = _resolveComponent("project-summary-completed-stats")
  const _component_project_summary_update = _resolveComponent("project-summary-update")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_project_summary_completed_stats, _mergeProps($options.statsModel, { class: "gfu-project-summary-completed__main" }), null, 16 /* FULL_PROPS */),
      ($props.projectLastUpdate)
        ? (_openBlock(), _createBlock(_component_project_summary_update, _mergeProps({ key: 0 }, $options.lastUpdateModel, { class: "gfu-project-summary-completed__aside" }), null, 16 /* FULL_PROPS */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}